<style scoped>
    @import url("~@/runtime-components/assets/common.css");

    .heatmap {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 2;
    }

    .map {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 0;

    }

    .background {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;
    }

    .background-img {
        background-image: url('./images/xiongan.jpg');
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>
<template>
    <div class="container">
        <div class="heatmap" ref="heatmap"></div>
        <div class="background background-img" v-if="isBackground"></div>
        <div class="map" :style="mapStyles" ref="map">
        </div>
    </div>
</template>

<script>
    import Konva from 'konva';
    import inMap from '@/runtime-components/lib/inmap.js';
    import axios from 'axios';

    export default {
        props: {
            url: {
                type: String,
                default: "/testdata/heatData.json"
            },
            radius: { //热力点半径
                type: Number,
                default: 30
            },
            opacity: {
                type: Number,
                default: 0.7
            },
            loop: { //轮询
                type: Boolean,
                default: true
            },
            loopTime: {
                type: Number,
                default: 5000
            },

            isEditing: {
                type: Boolean,
                default: false
            },
            isBackground: {
                type: Boolean,
                default: true
            },
            mapCenter: {
                type: Array,
                default () {
                    return [115.91985419419665, 39.055414347052036];
                }
            },
            mapZoom: {
                type: Number,
                default: 18.3
            }

        },
        data() {
            const cache = {
                inmap: null,
                bMap: null,
                stage: null,
                heatData: null,
                timer: null
            }
            return {
                getCache() {
                    return cache;
                }
            }
        },
        computed: {
            mapStyles() {
                return {
                    opacity: this.isBackground ? 0 : 1
                }
            }
        },
        watch: {
            url(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.start();
                }
            },
            radius(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.getCache().heatOverlay.setOptionStyle({
                        style: {
                            radius: Math.floor(newValue)
                        }
                    });
                }
            },
            opacity(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.getCache().heatOverlay.setOptionStyle({
                        style: {
                            maxOpacity: parseFloat(newValue)
                        }
                    });
                }
            },
            loopTime(newValue, oldValue) {
                if (newValue != oldValue) {

                }
            }
        },
        methods: {
            initMap() {
                let cache = this.getCache();
                // debugger
                let map = new window.BMapGL.Map(this.$refs.map); // 创建Map实例
                map.centerAndZoom(new window.BMapGL.Point(this.mapCenter[0], this.mapCenter[1]),
                    this.mapZoom); // 初始化地图,设置中心点坐标和地图级别
                map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
                map.addEventListener('moveend', () => {
                    const center = map.getCenter();
                    console.log(`Map: center:${JSON.stringify(center)} zoom:${map.getZoom()}`);
                });
                map.addEventListener('zoomend', () => {
                    const center = map.getCenter();
                    console.log(`Map: center:${JSON.stringify(center)} zoom:${map.getZoom()}`);
                });
                setTimeout(() => {
                    map.setTilt(30);
                    // map.setHeading(0);
                    setTimeout(() => {
                        this.start();
                    }, 2000);
                }, 500);

                cache.bMap = map;

            },
            initKonva() {
                let cache = this.getCache();
                const container = this.$refs.heatmap;
                const WIDTH = container.offsetWidth;
                const HEIGHT = container.offsetHeight;

                // 新建stage
                const stage = new Konva.Stage({
                    container: container,
                    width: WIDTH,
                    height: HEIGHT
                });
                cache.stage = stage;
                const tempLayer = new Konva.Layer({});

                stage.add(tempLayer);
                stage.draw();
                this.initHeatMap(tempLayer.getCanvas());
            },
            initHeatMap(container) {
                let cache = this.getCache();

                const heatOverlay = new inMap.HeatOverlay({
                    canvasDom: container._canvas,
                    style: {
                        radius: this.radius, // 半径
                        maxValue: 5,
                        maxOpacity: this.opacity
                    },
                    animation: {
                        type: 'time',
                        stepsRange: {
                            start: 0,
                            end: 100
                        },
                        trails: 10,
                        duration: 1,
                    },
                });

                cache.heatOverlay = heatOverlay;
            },
            getData() {
                return axios.get(this.url);
            },
            dealData(d) {
                let {
                    bMap
                } = this.getCache();

                let dataMap = {};

                for (let index = 0; index < d.length; index++) {
                    const item = d[index];

                    const pixel = bMap.pointToPixel(new BMapGL.Point(item.lng, item.lat));

                    const pixelData = {
                        y: pixel.y,
                        x: pixel.x,
                        count: Math.floor(item.count)
                    };
                    const time = `${item.time}`;
                    if (dataMap[time]) {
                        dataMap[time].push(pixelData);
                    } else {
                        dataMap[time] = [pixelData];
                    }
                }
                return dataMap;
            },
            loopDraw() {
                if (this.timer != null) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                const heatData = this.getCache().heatData;
                const keys = Object.keys(heatData);
                let index = 0;
                const drawFun = () => {
                    const key = keys[index++];
                    this.setHeatData(heatData[key]);

                    if (index + 1 >= keys.length) {
                        index = 0;
                    }
                    this.timer = setTimeout(drawFun, this.loopTime);
                }
                if (keys.length == 1) {
                    this.draw();
                } else if (keys.length > 1) {
                    drawFun();
                }

            },
            draw() {
                const heatData = this.getCache().heatData;
                const key = Object.keys(heatData)[0];
                this.setHeatData(heatData[key]);
            },
            setHeatData(data) {
                this.getCache().heatOverlay.setPixelData(data);
            },
            afreshDraw() {
                if (this.loop && this.isEditing == false) {
                    this.loopDraw();
                } else {
                    this.draw();
                }
            },
            start() {
                this.getData()
                    .then((response) => {
                        this.getCache().heatData = this.dealData(response.data);
                        if (this.loop && this.isEditing == false) {
                            this.loopDraw();
                        } else {
                            this.draw();
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            },
            resize() {
                const {
                    stage
                } = this.getCache();
                const container = this.$refs.heatmap;
                const width = container.offsetWidth;
                const height = container.offsetHeight;
                // debugger
                stage.width(width);
                stage.height(height);
                stage.draw();
                this.start();
            }
        },
        mounted() {
            console.log('mounted---')
            this.initMap();
            this.initKonva();

        },
        beforeDestroy() {
            let cache = this.getCache();
            for (const key in cache) {
                cache[key] = null;
            }
        }

    }
</script>